// Namespace for config opts
window.Config = {
  Admin: {}
};